import React, { useState } from "react";

const PongWindow = () => {
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-sunken-thin m-2 flex flex-wrap items-center justify-between gap-2 px-2 py-1 text-xs">
        <span>
          W / S : left paddle &nbsp;&nbsp;|&nbsp;&nbsp; ↑ / ↓ : right paddle &nbsp;&nbsp;|&nbsp;&nbsp; click the
          game once to start it. Desktop only.
        </span>
        <button
          type="button"
          onClick={() => setReloadKey((k) => k + 1)}
          className="win-btn win-focus-dotted shrink-0 px-2 py-0.5 text-[11px] font-bold"
        >
          ↺ Restart
        </button>
      </div>

      <div className="win-sunken-thin mx-2 mb-2 flex-1 overflow-hidden bg-black">
        <iframe
          key={reloadKey}
          src="/pong/index.html"
          title="Pong (Python - Pygame, compiled to WebAssembly)"
          className="h-full w-full border-0"
          allow="autoplay; gamepad"
        />
      </div>
    </div>
  );
};

export default PongWindow;
